import { Popper } from "@mui/material";

export const CustomPopper = function (props) {
  return (
    <Popper
      {...props}
      //style={styles.popper}
      placement="top"
    />
  );
};
